import {DmsRequest} from '../common/dms-request';
import {FunctionalHeader} from '../common/functional-header';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {UserInformation} from '../common/user-information';
import {SearchServiceOrdersRequestBody} from './search-service-orders-request-body';

export class SearchServiceOrdersRequest implements DmsRequest {
  readonly simpleName = 'search-orders';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: SearchServiceOrdersRequestBody;
}
